export type anyObj = {
    [key: string]: unknown,
    [index: number]: unknown
}
export type Transformer = (x: anyObj) => (anyObj | null | undefined);

export const isPrimitive = (x: unknown) => {
    switch (typeof x) {
        case 'boolean':
        case 'number':
        case 'string':
        case 'symbol':
        case 'undefined':
            return true;
        default:
            return false;

    }
}

const isHtmlElement = (x: unknown) =>
    (!global.__SERVER__ || global.__DEVSERVER__) && x instanceof HTMLElement

export const traverse = (obj: unknown, transform: Transformer, transformedObjs: Set<unknown> = new Set()) => {
    if (obj === null || isPrimitive(obj) || isHtmlElement(obj) || transformedObjs.has(obj)) {
        return obj;
    } else {
        const transformedObj = transform((obj as anyObj));
        transformedObjs.add(transformedObj);
        if (transformedObj === null || isPrimitive(transformedObj)) {
            return transformedObj;
        }
        Object.entries((transformedObj as anyObj)).forEach(([key, child]) => {
            (transformedObj as anyObj)[key] = traverse(child, transform, transformedObjs);
        });
        return transformedObj;
    }
}
